<template>
  <div>
    <div class="page-title">Admin Dashboard</div>

    <!-- ================= 基础统计 ================= -->
    <el-row :gutter="20" class="stats-row">
      <el-col :span="12">
        <el-card class="stats-panel today-panel" shadow="hover">
          <div class="panel-title">Today</div>
          <div class="stats-grid">
            <div class="stat-box">
              <div class="stat-label">Logins</div>
              <div class="stat-value">{{ stats.today_login || 0 }}</div>
            </div>
            <div class="stat-box">
              <div class="stat-label">Submissions</div>
              <div class="stat-value">{{ stats.today_submit || 0 }}</div>
            </div>
            <div class="stat-box">
              <div class="stat-label">Leaderboard Views</div>
              <div class="stat-value">{{ stats.today_view || 0 }}</div>
            </div>
            <div class="stat-box">
              <div class="stat-label">Registrations</div>
              <div class="stat-value">{{ stats.today_register || 0 }}</div>
            </div>
            <div class="stat-box">
              <div class="stat-label">Active Users</div>
              <div class="stat-value">{{ stats.active_users || 0 }}</div>
            </div>
          </div>
        </el-card>
      </el-col>

      <el-col :span="12">
        <el-card class="stats-panel total-panel" shadow="hover">
          <div class="panel-title">Total</div>
          <div class="stats-grid">
            <div class="stat-box">
              <div class="stat-label">Logins</div>
              <div class="stat-value">{{ stats.total_login || 0 }}</div>
            </div>
            <div class="stat-box">
              <div class="stat-label">Submissions</div>
              <div class="stat-value">{{ stats.total_submit || 0 }}</div>
            </div>
            <div class="stat-box">
              <div class="stat-label">Leaderboard Views</div>
              <div class="stat-value">{{ stats.total_view || 0 }}</div>
            </div>
            <div class="stat-box">
              <div class="stat-label">Registrations</div>
              <div class="stat-value">{{ stats.total_register || 0 }}</div>
            </div>
            <div class="stat-box stat-box-empty">
              <div class="stat-label"> </div>
              <div class="stat-value"> </div>
            </div>
          </div>
        </el-card>
      </el-col>
    </el-row>

    <el-row :gutter="20" class="content-row">
      <el-col :span="14">
        <el-card class="section-card chart-card">
          <div class="section-title">📈 Activity Trend</div>
          <div ref="chart" class="chart-box"></div>
        </el-card>
      </el-col>

      <el-col :span="10">
        <el-card class="section-card table-card">
          <div class="section-title">👥 Active Users</div>
          <el-table :data="users" border stripe class="dashboard-table">
            <el-table-column label="Email" prop="email"></el-table-column>
            <el-table-column label="Actions" prop="count" width="110"></el-table-column>
          </el-table>
        </el-card>

        <el-card class="section-card table-card" style="margin-top:20px;">
          <div class="section-title">📊 Dataset Usage (Submit)</div>
          <el-table :data="datasets" border stripe class="dashboard-table">
            <el-table-column label="Dataset" prop="name"></el-table-column>
            <el-table-column label="Usage Count" prop="count" width="130"></el-table-column>
          </el-table>
        </el-card>
      </el-col>
    </el-row>

  </div>
</template>

<script>
import * as echarts from "echarts";

export default {
  data() {
    return {
      stats: {},
      users: [],
      datasets: [],
      chart: null
    };
  },

  async mounted() {
    const user = JSON.parse(sessionStorage.getItem("user"));
    const token = user?.access_token;

    try {
      // ================= 基础统计 =================
      const res = await this.$http.get("/stats/overview", {
        headers: { Authorization: "Bearer " + token }
      });
      this.stats = res.data;

      // ================= 折线图 =================
      const trend = await this.$http.get("/stats/trend", {
        headers: { Authorization: "Bearer " + token }
      });
      this.initChart(trend.data);

      // ================= 活跃用户 =================
      const users = await this.$http.get("/stats/active_users", {
        headers: { Authorization: "Bearer " + token }
      });
      this.users = users.data;

      // ================= 数据集统计 =================
      const ds = await this.$http.get("/stats/datasets", {
        headers: { Authorization: "Bearer " + token }
      });
      this.datasets = ds.data;

    } catch (err) {
      this.$message.error("Failed to load analytics data");
    }
  },

  methods: {
    initChart(data) {
      this.chart = echarts.init(this.$refs.chart);

      this.chart.setOption({
        tooltip: {},
        xAxis: {
          type: "category",
          data: data.dates
        },
        yAxis: {
          type: "value"
        },
        series: [
          {
            data: data.counts,
            type: "line",
            smooth: true
          }
        ]
      });

      this.$nextTick(() => {
        this.chart.resize();
      });
    }
  }
};
</script>

<style scoped>
.stats-row {
  margin-top: 8px;
}

.stats-panel {
  border-radius: 18px;
  border: none;
  overflow: hidden;
}

.today-panel {
  background: linear-gradient(135deg, #f8fbff 0%, #eef4ff 100%);
}

.total-panel {
  background: linear-gradient(135deg, #fcfcfd 0%, #f3f4f6 100%);
}

.panel-title {
  font-size: 28px;
  font-weight: 700;
  color: #1f2a44;
  margin-bottom: 20px;
  letter-spacing: 0.4px;
}

.stats-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 16px;
}

.stat-box {
  background: #ffffff;
  border-radius: 14px;
  padding: 22px 16px;
  text-align: center;
  box-shadow: 0 4px 14px rgba(15, 23, 42, 0.06);
}

.stat-label {
  font-size: 14px;
  color: #6b7280;
  margin-bottom: 10px;
}

.stat-value {
  font-size: 34px;
  font-weight: 700;
  color: #111827;
  line-height: 1;
}

.page-title {
  font-size: 30px;
  font-weight: 700;
  color: #1f2a44;
  margin-bottom: 18px;
  letter-spacing: 0.3px;
}

.section-card {
  border-radius: 16px;
  border: none;
}

.stat-box-empty {
  visibility: hidden;
}

.content-row {
  margin-top: 20px;
}

.section-title {
  font-size: 20px;
  font-weight: 700;
  color: #1f2a44;
  margin-bottom: 16px;
  letter-spacing: 0.2px;
}

.chart-card {
  height: 100%;
  min-height: 640px;
}

.chart-box {
  height: 560px;
  width: 100%;
}

.table-card {
  min-height: 310px;
}

.dashboard-table {
  width: 100%;
}

.dashboard-table ::v-deep th {
  color: #374151;
  font-weight: 600;
  background: #f8fafc;
}

.dashboard-table ::v-deep td {
  color: #1f2937;
}
</style>